import { render, staticRenderFns } from "./ReportProductTable.vue?vue&type=template&id=6450f483&scoped=true&lang=html"
import script from "./ReportProductTable.vue?vue&type=script&lang=js"
export * from "./ReportProductTable.vue?vue&type=script&lang=js"
import style0 from "./ReportProductTable.vue?vue&type=style&index=0&id=6450f483&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6450f483",
  null
  
)

export default component.exports